import DashboardIcon from "@/assets/icons/dashboard-icon.svg";
import QuoteIcon from "@/assets/icons/quote-icon.svg";
import ProductIcon from "@/assets/icons/product-icon.svg";
import InventoryIcon from "@/assets/icons/inventory-icon.svg";
import ReviewIcon from "@/assets/icons/review-icon.svg";
import StarIcon from "@/assets/icons/rating-star.svg";
import UserIcon from "@/assets/icons/user-icon.svg";
import ApproveIcon from "@/assets/icons/approveIcon.svg";
import RejectIcon from "@/assets/icons/X-rejectIcon.svg";
import EmptyQuoteIcon from "@/assets/icons/emptyquoteIcon.svg";
import BrokenStarIcon from "@/assets/icons/broken-star-icon.svg";
import PackageIcon from "@/assets/icons/package-icon.svg";
import InventoryListIcon from "@/assets/icons/inventory-list-icon.svg";
import SettingsIcon from "@/assets/icons/package-icon.svg";
import NotificationIcon from "@/assets/icons/review-icon.svg";
import PaymentIcon from "@/assets/icons/quote-icon.svg";

export {
  DashboardIcon,
  QuoteIcon,
  ProductIcon,
  InventoryIcon,
  ReviewIcon,
  StarIcon,
  UserIcon,
  ApproveIcon,
  RejectIcon,
  EmptyQuoteIcon,
  PackageIcon,
  BrokenStarIcon,
  SettingsIcon,
  NotificationIcon,
  PaymentIcon,
  InventoryListIcon,
};
